import { render, staticRenderFns } from "./balanceRechargeRecord.vue?vue&type=template&id=548af634&scoped=true&"
import script from "./balanceRechargeRecord.vue?vue&type=script&lang=js&"
export * from "./balanceRechargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./balanceRechargeRecord.vue?vue&type=style&index=0&id=548af634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548af634",
  null
  
)

export default component.exports